import script from "./HDFVideoSection03.vue?vue&type=script&setup=true&lang=js"
export * from "./HDFVideoSection03.vue?vue&type=script&setup=true&lang=js"

import "./HDFVideoSection03.vue?vue&type=style&index=0&id=5cc129ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cc129ea"]])

export default __exports__